<template>
  <div id="delete-alert-popup" class="modal custom" role="dialog">
    <div class="modal-dialog modal-md">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header no-border">
          <div class="col-xs-12 text-right p-0">
            <img
              data-dismiss="modal"
              class="cursor-pointer"
              src="/static/images/icons/close_icon.svg"
              alt="close-icon"
            />
          </div>
        </div>
        <div class="modal-body p-0 text-center row m-0">
          <div class="col-xs-12 modal-body-text">
            <img
              class="modal-title text-center mb-20"
              src="/static/images/icons/delete_warning.svg"
              alt="delete-icon"
            />
            <p class="confirm_title text-center">
              Are you sure you would like to delete the selected alerts?
            </p>
            <p class="text-center fw-400 mb-40">
              Once you proceed, you will not be able to recover the information
              again.
            </p>
          </div>
        </div>
        <div class="modal-footer xs-flex-column">
          <button
            type="button"
            class="btn cancel emergo-white-button xs-mb-10"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            @click="deleteAlerts"
            type="button"
            class="btn emergo-green-button"
          >
            Delete
          </button>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '../UIComponents/Loader.vue';
import { deleteMultiAlertsDetails } from '../../apis/regulatoryUpdate';

export default {
  props: {
    selectedAlerts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loaderStatus: false,
    };
  },
  components: {
    Loader,
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },

    async deleteAlerts() {
      this.loaderStatus = true;
      const records = this.selectedAlerts.map((alert) => ({
        alertId: alert.alertId,
      }));
      const response = await deleteMultiAlertsDetails(records);
      this.loaderStatus = false;
      if (response.status) {
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'The alert(s) deleted successfully.',
          group: 'custom-notification',
        });
        this.$emit('loadRegistrationData');
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to delete alert!',
          group: 'custom-notification',
        });
      }
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}

.modal-footer .btn {
  width: 160px;
}

.mb-40 {
  margin-bottom: 40px;
}

.custom .modal-header {
  padding-left: 30px;
  border-bottom: 0 none;
  background-color: white;
  padding-right: 10px;
  padding-bottom: 0;
}

.modal-body {
  font-weight: 500;
  text-align: center;
  padding: 0;
}

.custom .modal-footer {
  border-top: 0 none;
  background-color: white;
  padding-top: 0;
}

.confirm_title {
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 32px;
  word-break: break-word;
}

.modal-content {
  border-radius: 10px !important;
}

.modal-dialog {
  max-width: 500px;
}

.text-start {
  text-align: start;
}

.mb-30 {
  margin-bottom: 30px;
}

.modal-body-text {
  padding-left: 60px;
  padding-right: 60px;
}

@media screen and (max-width: 767px) {
  .xs-mb-10 {
    margin-bottom: 10px;
  }

  .xs-flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (min-width: 768px) {
  .modal-footer .cancel {
    margin-right: 16px;
  }
}
</style>
